import {Controller} from "@hotwired/stimulus"
import Sortable from "sortablejs"
import Rails from '@rails/ujs';

export default class extends Controller {
  static values = { url: String }
  connect() {
    const that = this
    Sortable.create(this.element, {
      animation: 150,
      ghostClass: 'bg-orange-100',
      onEnd: that.end.bind(this)
    })
  }

  end(event) {
    let data = new FormData();
    const id = event.item.dataset.id;
    const newPosition = event.newIndex + 1;
    data.append('position', newPosition);

    Rails.ajax({
      url: this.urlValue.replace(":id", id),
      headers: {
        "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
      },
      type: 'PATCH',
      data: data,
      success: function(data) {},
      error: function(data) { event.from.insertBefore(event.item, event.from.children[event.oldIndex]); }
    })

  }
}
